export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const AUTH_CLEAR_ERROR = 'AUTH_CLEAR_ERROR';
